<template>
    <section id="testimonial">
 
 <div class="container">
   <div class="row">
     <div class="col-lg-5">
       <div class="mb-8 text-start">
         <h5 class="text-secondary">Testimonials </h5>
         <h3 class="fs-xl-10 fs-lg-8 fs-7 fw-bold font-cursive text-capitalize">What people say about Us.</h3>
       </div>
     </div>
     <div class="col-lg-1"></div>
     <div class="col-lg-6">
       <div class="pe-7 ps-5 ps-lg-0">
         <div class="carousel slide carousel-fade position-static" id="testimonialIndicator" data-bs-ride="carousel">
           <div class="carousel-indicators">
             <button class="active" type="button" data-bs-target="#testimonialIndicator" data-bs-slide-to="0" aria-current="true" aria-label="Testimonial 0"></button>
             <button class="false" type="button" data-bs-target="#testimonialIndicator" data-bs-slide-to="1" aria-current="true" aria-label="Testimonial 1"></button>
             <button class="false" type="button" data-bs-target="#testimonialIndicator" data-bs-slide-to="2" aria-current="true" aria-label="Testimonial 2"></button>
           </div>
           <div class="carousel-inner">
             <div class="carousel-item position-relative active">
               <div class="card shadow" style="border-radius:10px;">
                 <div class="position-absolute start-0 top-0 translate-middle"> <img class="rounded-circle fit-cover" src="../../assets/img/testimonial/author.png" height="65" width="65" alt="" /></div>
                 <div class="card-body p-4">
                   <p class="fw-medium mb-4">"Climbing Sigiriya was a highlight of my trip to Sri Lanka. The view from the top is absolutely breathtaking and worth every step of the climb. The historical significance and the beauty of the frescoes are unforgettable."</p>
                   <h5 class="text-secondary">Mike taylor</h5>
                   <p class="fw-medium fs--1 mb-0">Sussex, United Kingdom</p>
                 </div>
               </div>
               <div class="card shadow-sm position-absolute top-0 z-index--1 mb-3 w-100 h-100" style="border-radius:10px;transform:translate(25px, 25px)"> </div>
             </div>
             <div class="carousel-item position-relative ">
               <div class="card shadow" style="border-radius:10px;">
                 <div class="position-absolute start-0 top-0 translate-middle"> <img class="rounded-circle fit-cover" src="../../assets/img/testimonial/author2.png" height="65" width="65" alt="" /></div>
                 <div class="card-body p-4">
                   <p class="fw-medium mb-4">"Kandy was charming and peaceful, with its beautiful lake and the Temple of the Tooth. The local culture and the traditional Kandyan dance show were amazing. It's a great place to soak in the serene beauty of Sri Lanka."</p>
                   <h5 class="text-secondary">Thomas Wagon</h5>
                   <p class="fw-medium fs--1 mb-0">NYC, USA</p>
                 </div>
               </div>
               <div class="card shadow-sm position-absolute top-0 z-index--1 mb-3 w-100 h-100" style="border-radius:10px;transform:translate(25px, 25px)"> </div>
             </div>
             <div class="carousel-item position-relative ">
               <div class="card shadow" style="border-radius:10px;">
                 <div class="position-absolute start-0 top-0 translate-middle"> <img class="rounded-circle fit-cover" src="../../assets/img/testimonial/author3.png" height="65" width="65" alt="" /></div>
                 <div class="card-body p-4">
                   <p class="fw-medium mb-4">"Ella is a hidden gem in Sri Lanka. The train ride to Ella is one of the most scenic journeys I've ever experienced. The views of the tea plantations and the Ella Rock hike were highlights of my visit."</p>
                   <h5 class="text-secondary">Kelly Willium</h5>
                   <p class="fw-medium fs--1 mb-0">Ontario, Canada</p>
                 </div>
               </div>
               <div class="card shadow-sm position-absolute top-0 z-index--1 mb-3 w-100 h-100" style="border-radius:10px;transform:translate(25px, 25px)"> </div>
             </div>
           </div>
           <div class="carousel-navigation d-flex flex-column flex-between-center position-absolute end-0 top-lg-50 bottom-0 translate-middle-y z-index-1 me-3 me-lg-0" style="height:60px;width:20px;">
             <button class="carousel-control-prev position-static" type="button" data-bs-target="#testimonialIndicator" data-bs-slide="prev"><img src="../../assets/img/icons/up.svg" width="16" alt="icon" /></button>
             <button class="carousel-control-next position-static" type="button" data-bs-target="#testimonialIndicator" data-bs-slide="next"><img src="../../assets/img/icons/down.svg" width="16" alt="icon" /></button>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div><!-- end of .container-->
 
 </section>
 </template>
 
 <script>
 export default {
  name : 'TestMoni'
 }
 </script>
 
 <style>
 
 </style>